import { BackofficeSkeletonTheme } from "@acin.reactjs/acin-ui/backofficeSkeleton";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";
import { AppMediaQueries } from "./BreakpointsTheme";
import RouterTabsTheme from "./RouterTabsTheme";

const BackOfficeSkeletonTheme = (
  theme: DefaultTheme,
): ComponentCSSStyle<BackofficeSkeletonTheme> => ({
  root: {
    display: "flex",
    height: "100%",
    width: "100%",
    minWidth: "100%",
    position: "relative",

    [AppMediaQueries.maxTablet]: {
      display: "block",
    },
  },
  content: {
    root: {
      flexGrow: 1,
      minHeight: "0px",
    },
    routerTabs: {
      component: RouterTabsTheme(theme),
    },
  },
});

export default BackOfficeSkeletonTheme;
